export const rotationsInfoKeys = {
	rotationsInfo: (matchId: string) => ['ROTATIONS_INFO', matchId] as const,
	lastSequenceInfo: (matchId: string, game: number) => ['LAST_SEQUENCE', matchId, game] as const
};
